<template>
    <v-app style="width: 100%">
        <v-layout wrap class="pagamento-nav" align-center>
            <v-flex md3 class="logo">
                <img class="img-fill-aspect" :src="logo" alt="Logo Menu" />
            </v-flex>
            <v-flex md6>
                <p class="cabecalho white--text font-weight-bold text-center">OLÁ, SEJA BEM-VINDO(A)</p>
                <p class="white--text text-center" style="font-size: 14px">Confira seu pedido e depois efetue o pagamento</p>
            </v-flex>
            <v-flex class="d-flex justify-end" md3>
                <v-btn text class="white--text" @click="logout()" style="border: 0;">
                    Sair
                    <v-icon color="secondary" class="pa-2">power_settings_new</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-content class="pt-5" style="height: 100%">
            <FormaPagamento :value="pedido" />
        </v-content>
    </v-app>
</template>

<script>
  import { flavorRes, loadFlavor } from '@/plugins/flavors'
  import FormaPagamento from './FormaPagamento'
  import { Flavors } from '@/plugins/constants'

  export default {
    name: 'PagamentoCliente',
    components: {
      FormaPagamento
    },
    data: function () {
      return {
        logo: ''
      }
    },
    computed: {
      pedido () {
        return { id_pedido: this.$route.params.id_pedido }
      },
      flavor () {
        return this.$route.params.flavor || 'rodobens'
      }
    },
    mounted () {
      loadFlavor(this.flavor, true)
      this.logo = this.$session.get('flavor') === Flavors.ED ? flavorRes('img/logo-menu-branco.svg') : flavorRes('img/logo-menu-branco.png')
    },
    methods: {
      logout () {
        this.$router.push(`/cliente/login/${this.flavor}`)
      }
    }
  }
</script>

<style scoped lang="scss">
    .logo {
        height: 100%;
        padding: 12px 0;

        img {
            object-position: left;
        }
    }

    .box {
        width: 55px;
        height: 45px;
        background: #fff;
        border-radius: 10px;
    }

    .text {
        color: var(--accent);
        font-size: 16px;
    }

    .pagamento-nav {
        height: 80px;
        padding: 0 8px;
        background: var(--accent);
    }

    .card-resumo {
        width: 410px;
        border-radius: 10px;
        margin: 10px;
        padding: 30px;
    }

    .cabecalho {
        justify-content: flex-end;
        padding: 0 0 6px;
        margin: 12px 0px 0px 0px;
    }
</style>
